export default __webpack_public_path__ + "static/media/facebook-gaming-logo.58bc44f7.svg";